import { Model, settings } from "survey-core";

/**
 * Quiz schemas arrive from the API with `progressBarType: "questions"`, which measures how many
 * questions have been answered. Answers survive backwards navigation, so the bar freezes when the
 * user steps back. Page-based progress follows the visible step in both directions.
 *
 * `legacyProgressBarView` keeps the plain bar for the "pages" type — without it survey-core
 * renders the segmented "progress buttons" UI instead.
 */
export const configureProgressBar = (survey: Model) => {
    settings.legacyProgressBarView = true;
    survey.progressBarType = "pages";

    let lastPagePosition = -1;
    let lastProgress = 0;

    survey.getProgress = () => {
        const visiblePages = survey.visiblePages;
        const currentPage = survey.currentPage;
        if (visiblePages.length === 0 || !currentPage) return lastProgress;

        const progress = Math.ceil((visiblePages.indexOf(currentPage) * 100) / visiblePages.length);
        // Direction comes from the page's position in the schema rather than among the visible
        // pages, because conditional pages appearing or disappearing shift the visible index
        // without the user navigating anywhere.
        const pagePosition = survey.pages.indexOf(currentPage);
        const wentBack = pagePosition < lastPagePosition;

        lastPagePosition = pagePosition;
        // A revealed page grows the denominator and a hidden earlier page shrinks the index,
        // either of which lowers the ratio while the user stands still. Hold the previous value
        // so the bar only ever retreats when the user actually goes back.
        lastProgress = wentBack ? progress : Math.max(lastProgress, progress);

        return lastProgress;
    };
};
